import { combineReducers } from "redux";
import * as ACTIONS from '../constants/actions';

export default combineReducers({
    accounts: (state = [], action) => {
        switch (action.type) {
            case ACTIONS.SET_ACCOUNTS:
                return action.payload;
            case ACTIONS.CLEAR_ACCOUNTS:
                return [];
            default:
                return state;
        }
    }
})